import { Component, OnInit } from '@angular/core';
import { UserLogin } from '../../../Common/models/user.login';
import { VendorService } from '../../../Common/services/vendor.service';
import { RoleName, Dashboard, CommonConstants } from '../../../Common/Constants/common.constants';
import Highcharts from 'highcharts';
import { Router } from '@angular/router';
import { HomeService } from '../../services/home.service';
import { StorageService } from '../../../Common/services/storage.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastrService } from 'ngx-toastr';
import { UserRoleServiceService } from '../../../shared/services/user-role-service.service';
import { finalize } from 'rxjs';

@Component({
  selector: 'retailhub-home',
  templateUrl: './retailhub-home.component.html',
  styleUrls: ['./retailhub-home.component.css']
})

export class RetailHubHomeComponent implements OnInit {
  public selectedVendor: any;
  public selectedVendorID: any;
  public categoryList: any[] = [];
  public userCategoryList: any[] = [];
  public isITAdmin: boolean = false;
  public isSRETeam: boolean = false;
  public isSRESupport: boolean = false;
  public isCustomerSupportTeam: boolean = false;
  chart!: Highcharts.Chart;
  projectStatusGraph: any[] = [];
  projectStatusGraphData: any[] = [];
  onGoingExecutionGraph: any[] = [];
  onGoingExecutionGraphData: any[] = [];
  public dashboardButtonList: string[] = Dashboard.ButtonList;
  public projectsCount: number = 0;
  public salesPlanCount: number = 0;
  public storesCount: number = 0;
  public agencyCount: number = 0;
  public OnGoingProjectStoresCount: number = 0;
  selectedCategories: any[] = [];
  selectedDateRange: any;

  constructor(private vendorService: VendorService, private router: Router,
    private homeService: HomeService, private storageService: StorageService,
    private ngxService: NgxUiLoaderService, private toastr: ToastrService,
    private userRoleService: UserRoleServiceService
  ) {
  }

  async ngOnInit(): Promise<void> {
    let isReloadPage = this.storageService.getItem('IsReloadPage');
    if (!!isReloadPage) {
      this.storageService.setItem('IsReloadPage', false);
      window.location.reload();
    }
    this.getUserRoleInfo();
    await this.getHomePageInfo(undefined);
  }

  getUserRoleInfo() {
    let encodedVal = localStorage.getItem('UserRoleInfo');
    if (encodedVal != null) {
      let userRoleInfo: UserLogin = JSON.parse(atob(encodedVal));
      this.selectedVendor = userRoleInfo.vendors[0];
      this.selectedVendorID = this.selectedVendor.vendorID;
      this.vendorService.selectedVendor(this.selectedVendor.vendorName);
      this.categoryList = userRoleInfo.categories;

      this.isITAdmin = userRoleInfo.roles.some((a: any) => a.roleName == RoleName.ITAdmin);
      this.isSRETeam = userRoleInfo.roles.some((a: any) => (a.roleName == RoleName.SREAdmin || a.roleName == RoleName.SRESupport) && (a.write == true));
      this.isSRESupport = userRoleInfo.roles.some((a: any) => (a.roleName == RoleName.SRESupport) && (a.write == false));
      this.isCustomerSupportTeam = userRoleInfo.roles.some((a: any) => a.roleName == RoleName.CustomerTeam);

      // if(this.userRoleService.role?.roleID == 2
      //   || this.userRoleService.role?.roleID == 3 || this.userRoleService.role?.roleID == 4
      // ){
      this.categoryList = this.categoryList.map((x: any) => ({ 'label': x.categoryName, 'value': x.categoryID }));
      this.userCategoryList = userRoleInfo.userCategory;
      if (this.userRoleService.role?.roleID == 4 || this.userRoleService.role?.roleID == 1) {
        this.selectedCategories = this.userCategoryList.map(a => a.categoryID);
      } else {
        this.selectedCategories = this.categoryList.map(a => a.value);
      }
      // }

    }
  }

  async selectedCategoryList() {
    let dateRange: any = null;
    if (this.selectedDateRange?.length == 2 && this.selectedDateRange.every((a: any) => a != null)) {
      dateRange = this.selectedDateRange;
    }
    let homeDto = {
      categories: this.selectedCategories,
      vendorId: this.selectedVendorID,
      dateRange: dateRange ?? null
    };

    await this.getHomePageInfo(homeDto);

  }

  selectedSubmittedDateRange() {
    if (this.selectedDateRange?.length == 2 && this.selectedDateRange.every((a: any) => a != null)) {
      this.selectedCategoryList();
    }
  }

  async getHomePageInfo(homeDto: any) {
    if (!homeDto) {
      var date = new Date();
      this.selectedDateRange = [
        new Date(new Date().setMonth(date.getMonth() - 1)),
        new Date(new Date().setMonth(date.getMonth() + 4))
      ]
      homeDto = {
        categories: this.selectedCategories,
        vendorId: this.selectedVendorID,
        dateRange: this.selectedDateRange ?? null
      };
    }

    this.ngxService.start();

    this.homeService.GetHomeInformation(homeDto)
      .pipe(finalize(() => this.ngxService.stop()))
      .subscribe({
        next: (data: any) => {
          if (data) {
            this.projectsCount = data.projectsCount || 0;
            this.salesPlanCount = data.salesPlanCount || 0;
            this.storesCount = data.storeCount || 0;
            this.agencyCount = data.agencyCount || 0;
            this.OnGoingProjectStoresCount = data.onGoingProjectStoresCount || 0;

            this.getProjectsStatusCounts(homeDto);
          }
        },
        error: () => {
          this.toastr.clear();
          this.toastr.error("Unexpected error occurred");
        }
      });
  }
  async getProjectsStatusCounts(homeDto: any) {
    if (!homeDto) {
      homeDto = {
        categories: this.selectedCategories,
        vendorId: this.selectedVendorID,
        dateRange: this.selectedDateRange ?? null
      };
    }
    await this.homeService.getActiveProjects(homeDto).subscribe({
      next: (data: any) => {
        if (data) {
          this.projectStatusGraph = [];
          data.forEach((element: any) => {
            this.projectStatusGraph.push({ "name": element.statusName, "y": element.projectsCount });
          });
          setTimeout(() => {
            this.loadProjectsStatusChart();
          }, 100)
          this.getOnGoingExecutionCounts();
        }
      },
      error: (error) => {
        this.toastr.clear();
        this.toastr.error("Unexpected error occurred");
      }
    });
  }

  getOnGoingExecutionCounts() {
    this.onGoingExecutionGraph = [];
    let ongoingCount = this.projectStatusGraph.find((a: any) => a["name"] == CommonConstants.ExecutionOngoing);
    if (ongoingCount) {
      this.onGoingExecutionGraph.push({ "name": "PROJECT", "y": ongoingCount['y'] });
      this.onGoingExecutionGraph.push({ "name": "STORES", "y": this.OnGoingProjectStoresCount });
      this.onGoingExecutionGraph.push({ "name": "AGENCIES", "y": this.agencyCount });
    }
    setTimeout(() => {
      this.loadOnGoingExecutionChart();
    }, 100)
  }

  loadProjectsStatusChart() {
    this.projectStatusGraphData = [{
      data: this.projectStatusGraph,
      pointPadding: 0.4,
      pointPlacement: -0.1,
      colorByPoint: true,
      dataLabels: {
        enabled: true
      }
    }]
    let chart = Highcharts.chart('projectStatusChartcontainer', {
      chart: {
        type: 'column',
        height: 300
      },
      title: {
        text: '',
        style: {
          fontSize: '12px',
          fontWeight: '600',
          fontFamily: 'Arial Narrow'
        }
      },
      // tooltip: {
      //   enabled: false
      // },
      xAxis: {
        type: 'category'
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Number of Projects'
        }
      },
      legend: {
        shadow: true,
        layout: 'vertical',
        align: 'right',
        verticalAlign: 'top',
        x: -40,
        y: 80,
        floating: true,
        borderWidth: 1,
        enabled: false
      },
      plotOptions: {
        column: {
          grouping: false,
          shadow: false,
          borderWidth: 20
        }
      },
      series: this.projectStatusGraphData
    });
    this.chart = chart;
  }

  loadOnGoingExecutionChart() {
    this.onGoingExecutionGraphData = [{
      data: this.onGoingExecutionGraph,
      pointPadding: 0.4,
      pointPlacement: -0.2,
      colorByPoint: true,
      dataLabels: {
        enabled: true,
        align: 'center',     // Horizontal alignment: left, center, right
        verticalAlign: 'bottom' // Vertical alignment: top, middle, bottom
      }
    }]

    let chart = Highcharts.chart('onGoingExecutionChartcontainer', {
      chart: {
        type: 'bar',
        height: 200
      },
      title: {
        text: '',
        style: {
          fontSize: '12px',
          fontWeight: '600',
          fontFamily: 'Arial Narrow'
        }
      },
      xAxis: {
        type: 'category'
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Projects Count'
        }
      },
      legend: {
        shadow: true,
        layout: 'vertical',
        align: 'right',
        verticalAlign: 'top',
        x: -40,
        y: 80,
        floating: true,
        borderWidth: 1,
        enabled: false
      },
      plotOptions: {
        column: {
          grouping: false,
          shadow: false,
          borderWidth: 0
        }
      },
      series: this.onGoingExecutionGraphData
    });

    this.chart = chart;
  }

  stopPropagation(event: Event) {
    event.stopPropagation();
  }
  navigateToManageProjects() {
    this.router.navigate(['/manage-projects']);
  }
}
